import { api } from '../api';

export const accountService = {
  async fetchAccount() {
    return api.get('account');
  },

  async updateAccount(params) {
    return api.post('account', { '_method': 'PUT', ...params });
  },
};